// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._154ipxbi{top:var(--ds-space-200,1pc)}\n._16qs1dt4{box-shadow:var(--_qzf6oc)}\n._19bv1ejb{padding-left:var(--ds-space-300,24px)}\n._1bsb1vif{width:440px}\n._1xi2pxbi{right:var(--ds-space-200,1pc)}\n._bfhk13b4{background-color:var(--_1f6rtr1)}\n._ca0q1ejb{padding-top:var(--ds-space-300,24px)}\n._kqswstnw{position:absolute}\n._n3td1ejb{padding-bottom:var(--ds-space-300,24px)}\n._u5f31ejb{padding-right:var(--ds-space-300,24px)}", ""]);
// Exports
module.exports = exports;
